import React from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { AppContent } from "layout/AppContent";
import { LoadingProvider, ScreenSizeProvider } from "contexts/providers";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ScrollToTop } from "components/shared/ScrollToTop";
import { ComingSoon } from "components/comingSoon";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { esRutaTurbantes } from "constants/rutasTurbantes";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 60 * 1000,
      gcTime: 60 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});

const COMING_SOON_MODE = true;
const CUSTOM_IMAGE_PATH: string | null = "/img/optimized/coming-soon";

const App: React.FC = () => {
  const { pathname } = useLocation();
  const enTurbantes = esRutaTurbantes(pathname);

  // La landing de turbantes se reparte por canales privados mientras el resto del sitio
  // sigue en Coming Soon, así que queda exceptuada del gate.
  if (COMING_SOON_MODE && !enTurbantes) {
    return <ComingSoon imagePath={CUSTOM_IMAGE_PATH} />;
  }

  const reCaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

  const contenido = (
    <QueryClientProvider client={client}>
      <ScreenSizeProvider>
        <LoadingProvider>
          <ScrollToTop />
          <Routes>
            <Route path="*" element={<AppContent />} />
          </Routes>
        </LoadingProvider>
      </ScreenSizeProvider>
    </QueryClientProvider>
  );

  // El provider inyecta el badge flotante de reCAPTCHA, que queda encima de la esquina
  // inferior derecha de la landing y no forma parte del diseño. La landing no tiene
  // formularios —el CTA es un `mailto:`— y el unico consumidor del token es
  // `solicitudPresupuesto`, asi que en estas rutas no se monta.
  if (enTurbantes) {
    return contenido;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={reCaptchaKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {contenido}
    </GoogleReCaptchaProvider>
  );
};

export default App;
